import { HelpLink } from "../shell"
import { isArrayEmpty } from "../utils/array"
import { getIconClass, isArray } from "../utils/utils"
import { HelpDialog } from "./HelpDialog"
import { Msg } from "./Msg"
import { useOmniaContext } from "./context"
import { showDialog } from "./dialog"
import { DropDownMenu } from "./dropdown"
import * as usersnap from "../usersnap"

interface DialogHeaderProps {
    icon?: string
    help?: boolean | string[]
}

export const DialogHeader: React.FunctionComponent<React.PropsWithChildren<DialogHeaderProps>> = ({ children, icon, help }) => {

    const context = useOmniaContext()
    const { session, config, config: { support } } = context

    const reportFeedback = (e: React.MouseEvent) => {
        e.stopPropagation()
        usersnap.reportFeedback(session)
    }

    const cssClass = getIconClass(icon)

    const helpLinks = React.useMemo(() => {

        if (isArray(help)) {
            const records = support.getHelpLinks()
            const set = new Set(help)
            const links = Object.values(records)
                .flatMap(r => r)
                .filter(r => r.id && set.has(r.id))
                .map(r => ({
                    ...r,
                    title: r.title.replace("(@brand)", config.brand.name)
                }))
            if (isArrayEmpty(links)) return undefined
            return links
        }

    }, [config, help])


    const showHelpDialog = (link: HelpLink) => {
        showDialog({
            content: HelpDialog,
            contentProps: { link }
        })
    }

    return <div className="modal-header omnia-modal-header">
        <h3 className="modal-title">
            <i className={cssClass}></i>
            <span>{children}</span>
        </h3>
        {
            (help !== false) &&
            <div className="help">

                <DropDownMenu button={
                    <button id="help-menu" className="oa-btn-icon">
                        <i className="fas fa-question"></i>
                    </button>
                }>

                    <>

                        {
                            helpLinks &&
                            <>

                                {
                                    helpLinks.map(h => <li key={h.title} role="menuitem">
                                        <a onClick={() => showHelpDialog(h)}>
                                            <i className="icon icon-video" />
                                            {h.title}
                                        </a>
                                    </li>)
                                }

                                <li className="divider"></li>

                            </>

                        }

                        <li role="menuitem">
                            <a target="_blank" href="https://omniadigital.co.uk/release-notes/">
                                <i className="fa-solid fa-newspaper"></i>&nbsp;
                                What's new
                                &ndash;
                                Release notes
                            </a>
                        </li>
                        <li className="divider"></li>
                        <li role="menuitem">
                            <a onClick={reportFeedback}>
                                <i className="fa-solid fa-question"></i>&nbsp;
                                <Msg>Report feedback &ndash; Online support</Msg>
                            </a>
                        </li>
                        {
                            support.phone &&
                            <>
                                <li className="divider"></li>
                                <li role="menuitem" className="static">
                                    <a href="#">
                                        <i className="fas fa-phone-square-alt"></i>
                                        <Msg>Technical support line</Msg>
                                        &ndash;
                                        {support.phone}
                                    </a>
                                </li>
                            </>
                        }
                        {
                            support.email &&
                            <>
                                <li className="divider"></li>
                                <li role="menuitem">
                                    <a href={`mailto:${support.email}`}>
                                        <i className="fas fa-envelope-square"></i>
                                        <Msg>Email support/enquiries</Msg>
                                        &ndash;
                                        {support.email}
                                    </a>
                                </li>
                            </>
                        }

                    </>

                </DropDownMenu>

            </div>

        }

    </div>

}
